// Login logo colors, with related shades for grouped and stacked series.
export const CHART_COLORS = {
  blue: '#1F419B',
  blueDark: '#142B67',
  blueMedium: '#476BC0',
  blueLight: '#A6B8E3',
  yellow: '#FDB713',
  yellowDark: '#C58B00',
  yellowLight: '#FDD777',
  warning: '#B45309',
};



// WEBPACK FOOTER //
// ./src/components/dashboard2/chartColors.js